var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"privacy_module"},[_c('div',{staticClass:"privacy_module_cup"},[_c('div',[_c('div',{staticClass:"mainTitle"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"subTitle"},[_vm._v(_vm._s(_vm.subTitle))])]),_vm._v(" "),_c('div',{staticClass:"privacy_text",domProps:{"innerHTML":_vm._s(_vm.content)}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2da06f21","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/enViews/privacy/privacy.vue
// module id = null
// module chunks = 